const CloudEvent = {
  //
  // Cloud Events Track
  //
  // Settings Tutorial
  StartedSettingsTutorial: "Started Settings Tutorial",

  // Tutorial: Plus
  SettingsTutorialPlusTappedCenter: "Settings Tutorial - Plus Tapped Center",
  SettingsTutorialPlusSelectedNext: "Settings Tutorial - Plus Selected Next",
  SettingsTutorialPlusAutomaticTripTooltip: "Settings Tutorial - Plus Automatic Trip Tooltip",
  SettingsTutorialPlusManualTripTooltip: "Settings Tutorial - Plus Manual Trip Tooltip",
  SettingsTutorialPlusExpenseTooltip: "Settings Tutorial - Plus Expense Tooltip",
  SettingsTutorialPlusRevenueTooltip: "Settings Tutorial - Plus Revenue Tooltip",

  // Tutorial: Transactions
  SettingsTutorialTransactionsTappedRevenue: "Settings Tutorial - Transactions Tapped Revenue",
  SettingsTutorialTransactionsTapped1stExpense: "Settings Tutorial - Transactions Tapped 1st Expense",
  SettingsTutorialTransactionsTapped2ndExpense: "Settings Tutorial - Transactions Tapped 2nd Expense",
  SettingsTutorialTransactionsSelectedFinish: "Settings Tutorial - Transactions Selected Finish",

  // Tutorial: TripsAll
  SettingsTutorialTripsAllTapped1stTrip: "Settings Tutorial - TripsAll Tapped 1st Trip",
  SettingsTutorialTripsAllTapped2ndTrip: "Settings Tutorial - TripsAll Tapped 2nd Trip",
  SettingsTutorialTripsAllTapped3rdTrip: "Settings Tutorial - TripsAll Tapped 3rd Trip",
  SettingsTutorialTripsAllSwiped1stTrip: "Settings Tutorial - TripsAll Swiped 1st Trip",
  SettingsTutorialTripsAllSwiped2ndTrip: "Settings Tutorial - TripsAll Swiped 2nd Trip",
  SettingsTutorialTripsAllSwiped3rdTrip: "Settings Tutorial - TripsAll Swiped 3rd Trip",
  SettingsTutorialTripsAllSelectedAll: "Settings Tutorial - TripsAll Selected All",
  SettingsTutorialTripsAllSelected1stNext: "Settings Tutorial - TripsAll Selected 1st Next",
  SettingsTutorialTripsAllSelectedNext: "Settings Tutorial - TripsAll Selected Next",

  // Tutorial: Trips
  SettingsTutorialTripsSwipedWork: "Settings Tutorial - Trips Swiped Work",
  SettingsTutorialTripsSwipedPersonal: "Settings Tutorial - Trips Swiped Personal",
  SettingsTutorialTripsSwipedMedicalCharity: "Settings Tutorial - Trips Swiped Medical/Charity",
  SettingsTutorialTripsClickedSkip: "Settings Tutorial - Trips Clicked Skip",
  SettingsTutorialTripsClickedNext: "Settings Tutorial - Trips Clicked Next",

  // Trips Tutorial
  TripsTutorialStep1: "Trips Tutorial - Step 1",
  TripsTutorialStep2: "Trips Tutorial - Step 2",
  TripsTutorialStep3: "Trips Tutorial - Step 3",
  TripsTutorialStep4: "Trips Tutorial - Step 4",
  TripsTutorialSelectedDismiss: "Trips Tutorial - Selected Dismiss",
  TripsTutorialDeletedTrip: "Trips Tutorial - Deleted Trip",
  TripsTutorialStep1CompletedSuccess: "Trips Tutorial - Step 1 Completed Success",
  TripsTutorialStep2CompletedSuccess: "Trips Tutorial - Step 2 Completed Success",
  TripsTutorialStep3CompletedSuccess: "Trips Tutorial - Step 3 Completed Success",

  // Sharing
  SharedViaFacebook: "Shared via Facebook",
  ClickedCopyLink: "Clicked Copy Link",
  SharedViaTextMessage: "Shared via Text Message",
  SharedViaEmail: "Shared via Email",
  SharedViaContacts: "Shared via Contacts",

  SharedViaFacebookDataExport: "Shared via Facebook from Data Export",
  ClickedCopyLinkDataExport: "Clicked Copy Link from Data Export",
  SharedViaTextMessageDataExport: "Shared via Text Message from Data Export",
  SharedViaEmailDataExport: "Shared via Email from Data Export",
  SharedViaContactsDataExport: "Shared via Contacts from Data Export",

  // Taxes
  ClickedTaxesExpButton: "Clicked Taxes Exp Button",
  ClickedHRTab: "Clicked H&R Tab",
  ClickedScreen1CTA: "Clicked H&R Screen 1 CTA",
  ClickedScreen2CTA: "Clicked H&R Screen 2 CTA",
  ClickedTaxCenter: "Clicked Tax Center",
  ClickedAccountantTab: "Clicked Accountant Tab",

  // Company Manager
  ClickedAddCompanyManagerTab: "Clicked Add Company Manager Tab",

  // Home
  ClickedPremiumOffer: "Clicked Premium Offer",
  ClickedHRBlockOffer: "Clicked HRBlock Offer",
  ClickedAccountantOffer: "Clicked Accountant Offer",
  ClickedShareOffer: "Clicked Share Offer",
  ClickedReportOffer: "Clicked Report Offer",
  ClickedCobrandOffer: "Clicked Cobrand Offer",
  ClickedEnterpriseOffer: "Clicked Enterprise Offer",
  ClickedHomeClassifyNow: "Clicked Home Classify Now",
  ClickedRateOffer: "Clicked Rate Offer",

  // Transactions
  RevenueCreated: "Revenue Created",
  RevenueUpdated: "Revenue Updated",
  ExpenseCreated: "Expense Created",
  ExpenseUpdated: "Expense Updated",
  TransactionDeleted: "Transaction Deleted",
  SwipedTransactionDeleted: "Swiped Transaction Deleted",
  SwipedTransactionWork: "Swiped Transaction Work",
  SwipedTransactionPersonal: "Swiped Transaction Personal",
  SwipedTransactionOther: "Swiped Transaction Other",
  SwipedTransactionWorkAll: "Swiped Transaction Work All",
  SwipedTransactionPersonalAll: "Swiped Transaction Personal All",
  SwipedTransactionOtherAll: "Swiped Transaction Other All",
  FilteredTransactions: "Filtered Transactions",
  FilteredTransactionsDeleted: "Filtered Transactions Deleted",
  FilterAndClassifyTransactionsCompleted: "Filter And Classify Transactions Completed",

  // Trips
  TripCreated: "Trip Created",
  TripUpdated: "Trip Updated",
  TripDeleted: "Trip Deleted",
  StartedTripManually: "Started Trip Manually",
  StoppedTripManually: "Stopped Trip Manually",
  SwipedDeleted: "Swiped Deleted",
  SwipedWork: "Swiped Work",
  SwipedPersonal: "Swiped Personal",
  SwipedOther: "Swiped Other",
  SwipedWorkAll: "Swiped Work All",
  SwipedPersonalAll: "Swiped Personal All",
  SwipedOtherAll: "Swiped Other All",
  BatchClassify: "Batch Classify",
  BatchDeleted: "Batch Deleted",
  BatchMerged: "Batch Merged",
  BatchUnmerged: "Batch Unmerged",
  AutoDetectionSwitch: "Auto Detection Switch",
  AutoClassifyChanged: "Auto Classify Changed",
  FilteredTrips: "Filtered Trips",
  FilteredTripsDeleted: "Filtered Trips Deleted",
  FilterAndClassifyTripsCompleted: "Filter And Classify Trips Completed",

  // Notification
  NotificationSelectedBusinessLine: "Notification Selected Business Line",
  NotificationSelectedWork: "Notification Selected Work",
  NotificationSelectedPersonal: "Notification Selected Personal",
  NotificationSelectedCommute: "Notification Selected Commute",
  NewTripNotificationTapped: "New Trip Notification Tapped",
  NewTripNotificationDismissed: "New Trip Notification Dismissed",
  LocationServiceDenied: "Location Service Denied",
  PushNotificationsPermissionsEnabled: "Push Notifications Permissions Enabled",
  SyncedTransactionsTapped: "Synced Transactions Tapped",

  // Onboarding
  OnboardingStep1: "Onboarding - Step 1 Submitted",
  OnboardingStep2: "Onboarding - Step 2 Submitted",
  OnboardingStep3: "Onboarding - Step 3 Submitted",

  SignUp: "Sign Up",
  SignIn: "Sign In",
  DataExported: "Data Exported",
  AppLaunched: "App Launched",
  AppOpen: "App Open",

  DashboardLoadUser: "Dashboard Load User",

  // Deeplinks
  ExportDataDeepLinkOpened: "Export Data Deep Link Opened",
  ShareWallDeepLinkOpened: "Share Wall Deep Link Opened",
  PremiumDeepLinkOpened: "Premium Deep Link Opened",
  HRScreen1DeepLinkOpened: "HR Screen 1 Deep Link Opened",
  HRScreen2DeepLinkOpened: "HR Screen 2 Deep Link Opened",
  AccountantDeepLinkOpened: "Accountant Deep Link Opened",
  CobrandDeepLinkOpened: "Cobrand Deep Link Opened",
  EnterpriseDeepLinkOpened: "Enterprise Deep Link Opened",
  FavoriteTripsDeepLinkOpened: "Favorite Trips Deep Link Opened",
  BusinessLinesDeepLinkOpened: "Business Lines Deep Link Opened",

  // Health Insurance
  ClickedHealthInsurance: "Clicked Health Insurance",

  // Premium FAQ
  ClickedFAQ: "Clicked FAQ",
  ClickedFreeVsPremium: "Clicked Free vs Premium FAQ",

  // Plaid
  SelectedExistingInstitutionUser: "Selected Existing Institution User",
  AddNewInstitutionUser: "Add New Institution User",
  LoginToInstitutionUser: "Login To Institution User",
  RequestOtherInstitutionUser: "Request Other Institution User",
  RequestOtherInstitutionUserCompleted: "Request Other Institution User Completed",
  LoginToInstitutionUserComplete: "Login To Institution User Complete",
  UpdateInstitutionUserComplete: "Update Institution User Complete",
  ImportHistorySelectedAllPast: "Import History Selected All Past",
  ImportHistorySelectedLast30: "Import History Selected Last 30",
  ImportHistorySelectedJustFuture: "Import History Selected Just Future",
  SelectInstitutionAccountsComplete: "Select Institution Accounts Complete",
  DeleteInstitutionAccountsComplete: "Delete Institution Accounts Complete",
  SelectedDeleteInstitutionAccount: "Selected Delete Institution Account",
  SelectedRefreshInstitutionAccount: "Selected Refresh Institution Account",
  SelectedUpdateLoginInstitutionAccount: "Selected Update Login Institution Account",
  ToggledInstitutionAccount: "Toggled Institution Account",

  // Accountant
  AccountantInvitationSent: "Accountant Invitation Sent",
  AccountantInvitationAccepted: "Accountant Invitation Accepted",
  DataExportFromAccountant: "Data Export From Accountant",
  InvitationSentFromDataExport: "Invitation Sent From Data Export",
  AccountantUnlinked: "Accountant Unlinked",

  // Subscription
  LoadWebDashboard: "Load Web Dashboard",
  Premium: "Premium",

  // Filter
  FilterDates: "Filter Dates",
  FilterTypeExpense: "Filter Type - Expense",
  FilterTypeRevenue: "Filter Type - Revenue",
  FilterPurpose: "Filter Purpose",
  FilterBusinessLine: "Filter Business Line",
  FilterBankAccount: "Filter Bank Account",
  FilterFavoritePlace: "Filter Favorite Place",
  FilterCategory: "Filter By Category",
  FilterVehicle: "Filter By Vehicle",

  // Favorite Trip
  AddedFavoriteTrip: "Added Favorite Trip",
  UpdatedFavoriteTrip: "Updated Favorite Trip",

  // Favorite Place
  AddedFavoritePlace: "Added Favorite Place",
  UpdatedFavoritePlace: "Updated Favorite Place",

  // Work Hours
  ToggledWorkHours: "Toggled Work Hours",

  //
  // Cloud Events Properties
  //

  // Trips Tutorial
  CompletedTripsTutorial: "Completed Trips Tutorial",

  // Transactions
  HasCreatedRevenue: "Has Created Revenue",
  HasCreatedExpense: "Has Created Expense",

  // Trips
  HasCreatedManualTrip: "Has Created Manual Trip",
  AutoDetectionSwitchEnabled: "Auto Detection Switch Enabled",
  AutoClassifyAs: "Auto Classify As",

  // Email Preferences
  PushNotificationsEnabled: "Push Notifications Enabled",
  WeeklyReportEnabled: "Weekly Report Enabled",
  MonthlyReportEnabled: "Monthly Report Enabled",
  BadgeNotificationsEnabled: "Badge Notifications Enabled",

  // Work Hours
  WorkHoursEnabled: "Work Hours Enabled",

  // Export
  HasExportedData: "Has Exported Data",

  // Profile
  Email: "$email",
  Phone: "$phone",
  FirstName: "$first_name",
  LastName: "$last_name",
  IncomeSources: "income_sources",
  Persona: "Persona",
  Vehicles: "Vehicles",
  FavoritePlaces: "Favorite Places",
  FavoriteTrips: "Favorite Trips",
  Rating: "Rating",
  LocationServices: "Location Services",
  BeaconEnabled: "Beacon Enabled",
  BluetoothDeviceCount: "Bluetooth Device Count",
  Rated: "Rated",
  ClickedRateInAppStore: "Clicked Rate In App Store",
  ClickedRateLater: "Clicked Rate Later",
  RatePromptShownFromSettings: "Rate Prompt Shown From Settings",
  RatePromptShownFromTrips: "Rate Prompt Shown From Trips",
  RatePromptShownFromTransactions: "Rate Prompt Shown From Transactions",
  RatePromptShownFromHome: "Rate Prompt Shown From Home",
  SignUpDate: "Sign Up Date",

  UTMCampaign: "UTM Campaign",
  UTMSource: "UTM Source",
  UTMMedium: "UTM Medium",
  UTMContent: "UTM Content",
  UTMTerm: "UTM Term",

  TrialDaysRemaining: "Trial Days Remaining",
  FreeTripsRemaining: "Free Trips Remaining",
  TrialEndsAt: "Trial Ends At",
  HRLead: "hr_lead",

  // Plaid
  InstitutionUserCount: "Institution User Count",

  // Accountant vs Manager
  HasSentInviteAccountant: "Has Sent Invite Accountant",
  HasSentInviteManager: "Has Sent Invite Manager",
  HasReceivedInviteClient: "Has Received Invite Client",
  ClientUser: "Client User",
  AccountantUser: "Accountant User",


}
export default CloudEvent



// WEBPACK FOOTER //
// ./src/utils/CloudEvent.js